'use client';

import { createContext, type ReactNode, useContext } from 'react';

const CustomDomainContext = createContext(false);

export const CustomDomainProvider = ({
  isCustomDomain,
  children,
}: {
  isCustomDomain: boolean;
  children: ReactNode;
}) => <CustomDomainContext.Provider value={isCustomDomain}>{children}</CustomDomainContext.Provider>;

export const useIsCustomDomain = () => useContext(CustomDomainContext);
